import "../common/ControlBtn/index.css";
import "./index.css";

import { ReactComponent as RefreshBtnSvg } from "./refreshBtn.svg";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export default function RefreshBtn(props: Props) {
  return (
    <button
      type="button"
      {...props}
      className={[
        "bordered atomic atoms simple-part refresh-btn bg-white control-btn",
        props.className
      ].join(" ")}
    >
      <RefreshBtnSvg />
    </button>
  );
}
